import isProduction from './isProduction';
export default function isSnapshot() {
  return isProduction() && navigator.userAgent.includes('Node.js');
}